export default {
  landingPage: {
    name: "LandingPage",
    link: "",
    title: "Landing | Covesto",
  },
  auth: {
    name: "Auth",
    link: "",
    title: "Covesto",
    children: {
      login: {
        name: "login",
        link: "/login",
        title: "Login | Covesto",
      },
      verifyOtp: {
        name: "verifyOtp",
        link: "/verify-otp",
        title: "Verify Otp | Covesto",
      },
      completeProfile: {
        name: "completeProfile",
        link: "/complete-profile",
        title: "Complete Profile | Covesto",
      },
    },
  },
  adminPanel: {
    name: "adminPanel",
    link: "/admin/",
    title: "Admin || Covesto",
    children: {
      group: {
        name: "groups",
        link: "groups-verification",
        title: "Groups | Covesto",
      },
      videoCourses: {
        name: "videoCourses",
        link: "videos-verification",
        title: "Video Course | Covesto",
      },
      teams: {
        name: "Teams",
        link: "teams",
        title: "Admin Team | Covesto",
      },
      playlistDetail: {
        name: "playlistDetailAdmin",
        link: "admin-playlist-detail",
        title: "Playlist Detail | Covesto",
      },
      videoDetail: {
        name: "videoDetailAdmin",
        link: "admin-video-detail",
        title: "Video Detail | Covesto",
      },
    },
  },

  userPanel: {
    name: "userPanel",
    link: "",
    title: "User Panel | Covesto",
    children: {
      home: {
        name: "HomePage",
        link: "/home/:id",
        title: "Home | Covesto",
      },
      trending: {
        name: "TrendingPage",
        link: "/trending/",
        title: "Trending | Covesto",
        children: {
          main: {
            name: "mainPage",
            link: "main",
            title: "Main | Covesto",

            children: {
              premiumGroups: {
                name: "premiumGroups",
                link: "premium-groups",
                title: "Premium Groups | Covesto",
              },
              allGroups: {
                name: "allGroups",
                link: "all-groups/:id",
                title: "All Groups | Covesto",
              },
            },
          },
          markets: {
            name: "marketPage",
            link: "markets",
            title: "Market | Covesto",
          },
          news: {
            name: "newsPage",
            link: "news",
            title: "News | Covesto",
          },
          economic: {
            name: "EconomicCalendarPage",
            link: "economic-calendar",
            title: "Economic Calendar | Covesto",
          },
          report: {
            name: "ResearchReport",
            link: "reports",
            title: "Research Report | Covesto",
          },
          downloads: {
            name: "Downloads",
            link: "downloads",
            title: "Downloaded Report | Covesto",
          },
          gamification: {
            name: "Gamification",
            link: "gamification",
            title: "Gamification | Covesto",
          },
          premiumTrade: {
            name: "UnlockPremiumTrade",
            link: "unlockTrade",
            title: "Gamification | Covesto",
          },
          // webinars: {
          //   name: "WebinarsPage",
          //   link: "webinars",
          //   title: "Webinars | Covesto",
          // },
        },
      },
      webinars: {
        name: "WebinarsPage",
        link: "webinars",
        title: "Webinars | Covesto",
      },
      gamification: {
        name: "Gamification",
        link: "gamification",
        title: "Gamification | Covesto",
      },
      videoCourseList: {
        name: "VideoCourseList",
        link: "/video-course-list",
        title: "All Video Courses | Covesto",
      },
      premiumGroup: {
        name: "premiumGroup",
        link: "premium-groups/detail/:id",
        title: "Premium Group Details| Covesto",
      },
      myProfile: {
        name: "ProfilePage",
        link: "/my-profile",
        title: "My Profile | Covesto",
      },
      question: {
        name: "questionPage",
        link: "/questions",
        title: "Questioners | Covesto",
      },
      downloadTrade: {
        name: "downloadTrade",
        link: "/Download-Trade",
        title: "Download Trade | Covesto",
      },
      downloadTradeReportList: {
        name: "downloadTradeReportList",
        link: "/Download-Trade-Report-List",
        title: "Download Trade | Covesto",
      },
      copyExperTarde: {
        name: "copyTrade",
        link: "/copy-trade",
        title: "Copy Trade | Covesto",
      },
      followSebiUser: {
        name: "ExpertPage",
        link: "/Follow-SEBI-User",
        title: "Follow Expert | Covesto",
      },
      otherProfile: {
        name: "OthersProfilePage",
        link: "/profile/:id/:name",
        title: " Profile | Covesto",
      },
      network: {
        name: "NetworkPage",
        link: "/network",
        title: "Network | Covesto",
      },
      search: {
        name: "Search",
        link: "/search/:query",
        title: "Security Info | Covesto",
      },
      searchPage: {
        name: "SearchPage",
        link: "/search-page",
        title: "Global Search | Covesto",
      },
      recentSearch: {
        name: "RecentSearch",
        link: "/recent-search",
        title: "Recent Search | Covesto",
      },
      watchlistPage: {
        name: "WatchlistPage",
        link: "/watchlist",
        title: "Watchlist | Covesto",
      },
      newsDetail: {
        name: "newsDetail",
        link: "/news-detail/",
        title: "News Detail | Covesto",
      },
      notification: {
        name: "Notifications",
        link: "/notifications",
        title: "Notifications | Covesto",
      },
      groups: {
        name: "GroupDetails",
        link: "/groups/:id",
        title: "Group | Covesto",
      },
      transactions: {
        name: "transaction",
        link: "/transactions",
        title: "Transctions | Covesto",
      },
      membership: {
        name: "membership",
        link: "/membership",
        title: "Memberships | Covesto",
      },
      videoAndPlaylist: {
        name: "videoAndPlaylist",
        link: "/video-and-playlist",
        title: "Video And Playlist | Covesto",
      },
      playlistDetail: {
        name: "playlistDetail",
        link: "/playlist-detail",
        title: "Playlist Detail | Covesto",
      },
      videoDetail: {
        name: "videoDetail",
        link: "/video-detail",
        title: "Video Detail | Covesto",
      },
      tradingSection: {
        name: "tradingSection",
        link: "/trading",
        title: "Trading | Covesto",
      },
      portfolioEvaluation: {
        name: "portfolioEvaluation",
        link: "/portfolioEvaluation",
        title: "Review | Covesto",
      },
    },
  },
};
